export const DESK_IMAGES = [
  'https://blog.boltenergie.be/wp-content/uploads/2021/01/201021-BOLT-NEW-FACES-ILLIASTEIRLINCK-09-scaled.jpg', // Fany
  'https://blog.boltenergie.be/wp-content/uploads/2020/06/Employees-Pjotr.jpg', // Pjotr
  'https://blog.boltenergie.be/wp-content/uploads/2021/06/charlotte.jpg' // Charlotte
]
